import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const ShareAltSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      {...otherSvgProps}
    >
      <path
        d="M8.66667 9.33366H7.33333C5.02801 9.33366 3.02635 10.6338 2.02159 12.5408C2.00729 12.3625 2 12.1823 2 12.0003C2 8.31846 4.98477 5.33366 8.66667 5.33366V1.66699L15.6667 7.33366L8.66667 13.0003V9.33366ZM7.33333 8.00033H10V10.2055L13.5476 7.33366L10 4.46182V6.66699H8.66667C7.053 6.66699 5.60674 7.38359 4.62875 8.51599C5.47249 8.18126 6.38694 8.00033 7.33333 8.00033Z"
        fill={fill}
      />
    </svg>
  </span>
);

export default ShareAltSVG;
